import { uid } from "./postprocess";
import { hasWordTiming, tokens } from "./lines";

export const sortCaps = (caps) => [...caps].sort((a, b) => a.start - b.start);

export const updateCap = (caps, id, patch) => caps.map((c) => (c.id === id ? { ...c, ...patch, flag: patch.text !== undefined ? null : c.flag } : c));

export const deleteCap = (caps, id) => caps.filter((c) => c.id !== id);

export function splitCap(caps, id, pos) {
  const i = caps.findIndex((c) => c.id === id);
  const c = caps[i];
  let p = pos > 0 && pos < c.text.length ? pos : Math.floor(c.text.length / 2);
  if (c.text[p] !== " " && c.text[p - 1] !== " ") {
    const l = c.text.lastIndexOf(" ", p);
    const r = c.text.indexOf(" ", p);
    if (l > 0 || r > 0) p = r < 0 || (l > 0 && p - l <= r - p) ? l : r;
  }
  const a = c.text.slice(0, p).trim();
  const b = c.text.slice(p).trim();
  if (!a || !b) return caps;
  let mid = +(c.start + (c.end - c.start) * (p / c.text.length)).toFixed(3);
  let wa, wb;
  if (hasWordTiming(c)) {
    const k = tokens(a).length;
    wa = c.words.slice(0, k);
    wb = c.words.slice(k);
    mid = +((wa[wa.length - 1].e + wb[0].s) / 2).toFixed(3);
  }
  const next = [...caps];
  next.splice(i, 1, { ...c, text: a, end: mid, flag: null, words: wa }, { id: uid(), start: mid, end: c.end, text: b, flag: null, words: wb });
  return next;
}

export function mergeNext(caps, id) {
  const i = caps.findIndex((c) => c.id === id);
  if (i < 0 || i >= caps.length - 1) return caps;
  const a = caps[i];
  const b = caps[i + 1];
  const next = [...caps];
  const words = hasWordTiming(a) && hasWordTiming(b) ? [...a.words, ...b.words] : undefined;
  next.splice(i, 2, { ...a, text: `${a.text} ${b.text}`.trim(), end: Math.max(a.end, b.end), flag: null, words });
  return next;
}

export function addAt(caps, t, duration) {
  const after = caps.filter((c) => c.start > t)[0];
  const end = Math.min(after ? after.start : duration || t + 2, t + 2);
  const c = { id: uid(), start: +t.toFixed(3), end: +Math.max(end, t + 0.5).toFixed(3), text: "New caption", flag: null };
  return { caps: sortCaps([...caps, c]), id: c.id };
}

export function replaceAll(caps, find, repl, matchCase) {
  if (!find) return { caps, count: 0 };
  const re = new RegExp(find.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), matchCase ? "g" : "gi");
  let count = 0;
  const next = caps.map((c) => {
    const m = c.text.match(re);
    if (!m) return c;
    count += m.length;
    return { ...c, text: c.text.replace(re, repl), flag: null };
  });
  return { caps: next, count };
}
